var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMultilocationIcon = function SvgMultilocationIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 45,
    viewBox: "0 0 38 45",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57442 5.48968C12.9922 -1.82989 25.0078 -1.82989 32.4256 5.48968C39.8581 12.8239 39.8581 24.7261 32.4256 32.0603C32.4154 32.0703 32.4052 32.0802 32.3948 32.09L20.374 43.4552C19.603 44.1842 18.397 44.1842 17.626 43.4552L5.60516 32.09C5.59481 32.0802 5.58456 32.0703 5.57442 32.0603C-1.85814 24.7261 -1.85814 12.8239 5.57442 5.48968ZM29.6161 8.33689C23.756 2.55437 14.244 2.55437 8.38395 8.33689C2.5436 14.0999 2.53869 23.4295 8.36922 29.1986L19 39.2495L29.6308 29.1985C35.4613 23.4295 35.4564 14.0999 29.6161 8.33689Z",
    fill: "#0357FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19C11 14.5817 14.5817 11 19 11C23.4183 11 27 14.5817 27 19C27 23.4183 23.4183 27 19 27C14.5817 27 11 23.4183 11 19ZM19 15C16.7909 15 15 16.7909 15 19C15 21.2091 16.7909 23 19 23C21.2091 23 23 21.2091 23 19C23 16.7909 21.2091 15 19 15Z",
    fill: "#0357FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultilocationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multilocation-icon.801429b6.svg";
export { ForwardRef as ReactComponent };